// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIdNameDto
 */
export interface IIdNameDto {
    /**
     * 
     * @type {number}
     * @memberof IIdNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IIdNameDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IIdNameDto interface.
 */
export function instanceOfIIdNameDto(value: object): value is IIdNameDto {
    return true;
}

export function IIdNameDtoFromJSON(json: any): IIdNameDto {
    return IIdNameDtoFromJSONTyped(json, false);
}

export function IIdNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIdNameDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IIdNameDtoToJSON(json: any): IIdNameDto {
    return IIdNameDtoToJSONTyped(json, false);
}

export function IIdNameDtoToJSONTyped(value?: IIdNameDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

